<div [ngStyle]="{'background-image': 'url(\''+ src + '\')'}">
    <ng-content></ng-content>
</div>
